import cookie from 'js-cookie';

import { JWT_COOKIE } from '~/features/cookies/constants';

import { getUserIdFromJwt } from './get-user-id-from-jwt';

export const maybeJwt = cookie.get(JWT_COOKIE);

export const userId = maybeJwt ? getUserIdFromJwt(maybeJwt) : undefined;
